import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { User, Save, Loader2 } from 'lucide-react';

export const TaxIdentifiersCard = ({ taxIds, setTaxIds, onSave, saving }) => (
  <Card className="bg-slate-800 border-slate-700 border-l-4 border-l-amber-500" data-testid="tax-identifiers-card">
    <CardHeader className="pb-2">
      <CardTitle className="text-white flex items-center gap-2 text-base">
        <User className="h-5 w-5 text-amber-400" />
        Your Tax Details
      </CardTitle>
    </CardHeader>
    <CardContent>
      <p className="text-xs text-slate-500 mb-3">
        Your accountant needs these to prepare your tax return. Enter them here so they're always available.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="space-y-1">
          <Label className="text-slate-400 text-xs">National Insurance Number</Label>
          <Input value={taxIds.ni_number} onChange={e => setTaxIds(p => ({...p, ni_number: e.target.value}))}
            placeholder="e.g. AB 12 34 56 C"
            className="bg-slate-900 border-slate-600 text-white h-8 text-sm uppercase"
            data-testid="ni-number-input" />
        </div>
        <div className="space-y-1">
          <Label className="text-slate-400 text-xs">UTR (Self Assessment)</Label>
          <Input value={taxIds.utr} onChange={e => setTaxIds(p => ({...p, utr: e.target.value}))}
            placeholder="e.g. 1234567890"
            className="bg-slate-900 border-slate-600 text-white h-8 text-sm"
            data-testid="utr-input" />
        </div>
        <div className="space-y-1">
          <Label className="text-slate-400 text-xs">Date of Birth</Label>
          <Input type="date" value={taxIds.date_of_birth} onChange={e => setTaxIds(p => ({...p, date_of_birth: e.target.value}))}
            className="bg-slate-900 border-slate-600 text-white h-8 text-sm"
            data-testid="dob-input" />
        </div>
      </div>
      <div className="mt-3">
        <Button size="sm" onClick={onSave} disabled={saving}
          className="bg-amber-600 hover:bg-amber-700 h-8" data-testid="save-tax-ids-btn">
          {saving ? <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" /> : <Save className="h-3.5 w-3.5 mr-1.5" />}
          Save Details
        </Button>
      </div>
    </CardContent>
  </Card>
);
